export default "__VITE_ASSET__BQ9xYQ_Z__"